var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getOverlay)?_c('div',{staticClass:"loader-overlay"},[_c('clip-loader',{staticClass:"spinner",attrs:{"color":"#F78021"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }